class Controller {
  constructor($mdToast, options) {
    "ngInject";

    this.$mdToast = $mdToast;
    this.options = options;
    // Support reading message from options object or optons.error object
    // Due to new error response schema from integration with oathkeeper
    this.toastMessage = options.message || options.error.message;
  }

  close() {
    this.$mdToast.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/notification/toast/toast.controller.js